import moment from 'moment';
import { DATE_LOCALES, DEFAULT_LANGUAGE } from '../constants/locales';

export const getDateLocale = (language) => DATE_LOCALES[language] || DATE_LOCALES[DEFAULT_LANGUAGE];

export const applyMomentLocale = (language) => moment.locale(getDateLocale(language).moment);
